const accessLogo = new URL('../../../assets/ron/ronneby-mina-sidor-logo.png', import.meta.url).href;

// Load Google Fonts - Work Sans (huvudtypsnitt) och Lobster (accenter) enligt Ronnebys grafiska profil
if (typeof document !== 'undefined') {
  const ronnebyLightFont = document.createElement('link');
  ronnebyLightFont.rel = 'stylesheet';
  ronnebyLightFont.href =
    'https://fonts.googleapis.com/css2?family=Work+Sans:wght@100..900&family=Lobster&family=Lora:ital,wght@0,400..700;1,400..700&display=swap';
  document.head.appendChild(ronnebyLightFont);
}

export const ronnebyLight = {
  name: 'ronneby:light',
  extends: 'citizen:light',
  cssPath: 'custom/styles/ron/ronneby-light.theme',
  vuetify: {
    defaults: {
      AppAccessPage: {
        logoSrc: accessLogo,
        logoAlt: 'Ronneby kommun – Mina sidor',
        backgroundSrc: new URL('../../../assets/ron/bg1.jpg', import.meta.url).href,
      },
      HItemCard: {
        HScopedItemCardActionBtn: {
          color: 'primary-darken-1',
          variant: 'flat',
        },
      },
      HSearchItemsResults: {
        HItemCard: {
          HScopedItemCardActionBtn: {
            color: 'primary-darken-1',
            variant: 'flat',
          },
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        // Primära blå färger (Ronnebys huvudfärg)
        primary: '#0087cb', // Pantone 3005 - huvudfärg
        'on-primary': '#FFFFFF',
        'primary-lighten-1': '#0091d4', // Pantone Process
        'primary-lighten-2': '#92d0f0', // Pantone 2905
        'primary-lighten-3': '#d5e2e7', // Pantone 5455
        'primary-darken-1': '#043e66', // Pantone 7694 - mörk blå

        // Sekundär färg - turkos
        secondary: '#46bac6', // Pantone 325
        'on-secondary': '#FFFFFF',
        'secondary-lighten-1': '#79cdd6', // Pantone 2225
        'secondary-darken-1': '#197285', // Pantone 7713

        'search-list-hover': '#d5e2e7',

        // Felmeddelanden - röd/orange
        error: '#9a2522', // Pantone 187
        'on-error': '#FFFFFF',
        'error-lighten-1': '#d94527', // Pantone 485
        'error-lighten-2': '#f9a876', // Pantone 2017
        'on-error-lighten-2': '#292929',
        'error-lighten-3': '#ffe1c2', // Pantone 475

        // Framgång - grön
        success: '#00963d', // Pantone 354
        'on-success': '#FFFFFF',
        'success-lighten-1': '#7ebc54', // Pantone 360

        // Varning - gul/orange
        warning: '#f9823e', // Pantone 1575
        'on-warning': '#FFFFFF',
        'warning-lighten-1': '#f9a876', // Pantone 2017
        'warning-lighten-2': '#ffcea0', // Pantone 2015
        'warning-lighten-3': '#fff7d7', // Pantone Yellow 0131

        // Ytor
        surface: '#FFFFFF',
        'on-surface': '#3e3d3f', // Pantone 447
        'surface-variant': '#d5e2e7', // Ljusblå
        'on-surface-variant': '#043e66',

        // Bakgrunder
        background: '#F8F8F8',
        'on-background': '#3e3d3f',
        'background-3': '#d5e2e7',
        'on-background-3': '#3e3d3f',
        'background-4': '#FFFFFF',
        'on-background-4': '#3e3d3f',

        // Neutrala
        black: '#3e3d3f', // Pantone 447
        'on-black': '#FFFFFF',
        'black-lighten-1': '#545355', // Pantone 418
        gray: '#545355',
        'gray-lighten-1': '#918977', // Pantone Warm Grey 7
        'gray-lighten-2': '#ececec',
        white: '#FFFFFF',
        'white-darken-1': '#d5e2e7',

        // Accentfärger
        red: '#d94527', // Pantone 485
        'on-red': '#FFFFFF',
        cyan: '#0091d4', // Pantone Process
        'on-cyan': '#FFFFFF',
        yellow: '#fff482', // Pantone 100
        'on-yellow': '#3e3d3f',
        green: '#00963d', // Pantone 354

        // Badges
        'badge-disabled': '#ececec',
        'on-badge-disabled': '#545355',
        'badge-primary': '#0087cb',
        'on-badge-primary': '#FFFFFF',
        'badge-secondary': '#92d0f0',
        'on-badge-secondary': '#043e66',
        'badge-tertiary': '#fff482',
        'on-badge-tertiary': '#3e3d3f',

        // Ronneby-specifika färger (ersätter skog/strand)
        skog: '#043e66', // Mörk blå
        'on-skog': '#FFFFFF',
        strand: '#92d0f0', // Ljus blå
        'on-strand': '#043e66',
        'strand-lighten-1': '#d5e2e7',
        'strand-lighten-2': '#ececec',

        // UI-element
        disabled: '#ececec',
        'on-disabled': '#545355',
        loader: '#0087cb',
        'loader-background': '#d5e2e7',
        'text-color-primary': '#3e3d3f',
        'text-color-secondary': '#545355',

        // Kategorier
        fullmakter: '#F8F8F8',
        ovriga: '#FFFFFF',
        utbildning: '#d881b4',
        omsorg: '#FFFFFF',
        forening: '#63365f',
        adshavare: '#fa485b',
        foretag: '#46bac6',
        'on-foretag': '#FFFFFF',
        fastigheter: '#7ebc54',
        'on-fastigheter': '#FFFFFF',

        // Page header background colors (matching category colors)
        'page-companies-header-bg': '#00000000',
        'on-page-companies-header-bg': '#FFFFFF',
        'page-properties-header-bg': '#00000000',
        'on-page-properties-header-bg': '#FFFFFF',
        'page-associations-header-bg': '#00000000',
        'on-page-associations-header-bg': '#FFFFFF',
        'page-authorizations-header-bg': '#FFFFFF',
        'on-page-authorizations-header-bg': '#3e3d3f',
        'page-children-header-bg': '#FFFFFF',
        'on-page-children-header-bg': '#3e3d3f',
        'page-enrollments-header-bg': '#FFFFFF',
        'on-page-enrollments-header-bg': '#3e3d3f',
        'page-employments-header-bg': '#FFFFFF',
        'on-page-employments-header-bg': '#3e3d3f',
        'page-eservices-header-bg': '#FFFFFF',
        'on-page-eservices-header-bg': '#3e3d3f',
        'page-cases-header-bg': '#FFFFFF',
        'on-page-cases-header-bg': '#3e3d3f',

        // Item card border colors (card-*) — Ronneby grafisk profil
        'card-company': '#46bac6', // Turkos (Pantone 325)
        'card-property': '#7ebc54', // Grön (Pantone 360)
        'card-authorization': '#e1cd7c', // Gul (Pantone 460)
        'card-child': '#fa485b', // Röd (Pantone 213)
        'card-enrollment': '#d881b4', // Lila (Pantone 673)
        'card-employment': '#d881b4', // Lila (Pantone 673)
        'card-case': '#0087cb', // Blå (Pantone 3005)
        'card-eservice': '#0272BA', // Blå (Pantone 285)
        'card-facility': '#f79da7', // Rosa (Pantone 1905)
        'card-berth': '#0091d4', // Blå (Pantone Process)
        'card-association': '#63365f', // Dark purple profile color
        'card-servingpermit': '#46bac6', // Rosa (Pantone 225)
        'card-servingplace': '#46bac6', // Turkos (Pantone 325)
        'card-salespermit': '#46bac6', // Orange ljus (Pantone 2017)
        'card-salespoint': '#46bac6', // Turkos (Pantone 325)

        // Sektorer
        'sector-privat': '#79cdd6', // Turkos ljus
        'sector-företag': '#7ebc54', // Grön ljus (Pantone 360)
        'on-sector-privat': '#3e3d3f',
        'on-sector-företag': '#3e3d3f',

        // Startsida och navigation
        'start-page': '#F8F8F8',
        'on-start-page': '#3e3d3f',
        'bulletin-board': '#92d0f0',
        'on-bulletin-board': '#043e66',
        scrollbar: '#0087cb',
        toolbar: '#d5e2e7',
        'on-toolbar': '#3e3d3f',
        'breadcrumb-hover': '#92d0f0',
        'on-breadcrumb': '#043e66',

        // Processstatus - Ronnebys basfärger
        'process-state-active': '#0087cb', // Blå (Pantone 3005) - pågående
        'on-process-state-active': '#FFFFFF',
        'process-state-inactive': '#d5e2e7', // Ljusblå/grå (Pantone 5455)
        'on-process-state-inactive': '#545355',
        'process-state-done': '#2f812a', // Grön (Pantone 2258) - avklarat
        'on-process-state-done': '#FFFFFF',
        'process-state-error': '#9a2522', // Röd (Pantone 187) - fel
        'on-process-state-error': '#FFFFFF',
        'process-state-skipped': '#46bac6', // Turkos (Pantone 325)
        'on-process-state-skipped': '#FFFFFF',

        // Bulletiner
        'bulletin-informational': '#FFFFFF',
        'on-bulletin-informational': '#3e3d3f',
        'bulletin-warning': '#fff7d7', // Ljusgul
        'on-bulletin-warning': '#3e3d3f',
        'bulletin-critical': '#d94527',
        'on-bulletin-critical': '#FFFFFF',
        'bulletin-skipped': '#92d0f0',
        'on-bulletin-skipped': '#043e66',

        // Knappar
        'header-button': '#92d0f0',
        'on-header-button': '#043e66',
        'dialog-header-button': '#3e3d3f',
        'focus-ring': '#0091d4',

        // Chips
        'chip-active': '#0087cb',
        'on-chip-active': '#FFFFFF',
      },
    },
  },
};
